import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';
import { DrawApi } from '@apply/api';
import { DrawType } from '@apply/constants';
import { AddDrawCard } from './AddDrawCard';
import { PendingDrawCard } from './PendingDrawCard';
import { BlockedDrawCard } from './BlockedDrawCard';
import { ResignDrawCard } from './ResignDrawCard';
import { ContinueDrawCard } from './ContinueDrawCard';

interface LoanDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
    set_modalDashboarDrawBudget: React.Dispatch<React.SetStateAction<DrawApi.IDashboardDrawBudget | undefined>>;
}
export const LoanDrawCard: React.FC<LoanDrawCardProps> = ({ dashboardDrawBudget, set_modalDashboarDrawBudget }) => {
    const Card = () => {
        const { canAddDraw, isApproved, isEquityMet, isBudgetMaxed, borrowerSubmitted, needsBorrowerSignature, latestDrawType } =
            dashboardDrawBudget;

        if (canAddDraw) {
            return (
                <AddDrawCard
                    dashboardDrawBudget={dashboardDrawBudget}
                    set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
                />
            );
        }

        if (latestDrawType == DrawType.Manual && !borrowerSubmitted) {
            return (
                <ContinueDrawCard
                    dashboardDrawBudget={dashboardDrawBudget}
                    set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
                />
            );
        }

        if (borrowerSubmitted && needsBorrowerSignature) {
            return (
                <ResignDrawCard
                    dashboardDrawBudget={dashboardDrawBudget}
                    set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
                />
            );
        }

        if (!isApproved || !isEquityMet || isBudgetMaxed) {
            return (
                <BlockedDrawCard
                    dashboardDrawBudget={dashboardDrawBudget}
                    set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
                />
            );
        }

        return (
            <PendingDrawCard
                dashboardDrawBudget={dashboardDrawBudget}
                set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
            />
        );
    };
    return (
        <Panel
            key={dashboardDrawBudget.loanId}
            theme={PanelTheme.White}
            borderStyle={PanelBorderStyle.Solid}
            borderRadius={PanelBorderRadius.Small}
            padding={16}
        >
            <Card />
        </Panel>
    );
};
